import { createMutation } from '../common';
import * as apis from '../apis/funnel-analyses';

export const useCreateFunnelAnalysis = createMutation({
  mutationFn: apis.postFunnelAnalysis,
});

export const useUpdateFunnelAnalysis = createMutation({
  mutationFn: apis.putFunnelAnalysis,
});

export const useDeleteFunnelAnalysis = createMutation({
  mutationFn: apis.deleteFunnelAnalysis,
});

export const useUpsertFunnelAnalysis = createMutation((id?: string) => ({
  mutationFn: async (data: Parameters<typeof apis.postFunnelAnalysis>[0]) => {
    if (id) {
      return apis.putFunnelAnalysis({ id, data });
    }

    return apis.postFunnelAnalysis(data);
  },
}));
